<template>
  <div class="d-flex align-center">
    <v-checkbox
      v-model="isHorarioCheckboxMarcado"
      :readonly="readonly"
      :label="titulo"
      class="mr-3"
      style="min-width: 80px"
    />

    <time-picker
      label="Início"
      hide-details
      class="mr-2"
      :time-iso="horarioInicialIso"
      :min-time-iso="horarioMinimoIso"
      :max-time-iso="horarioMaximoIso"
      :allowed-hours="horarioInicialAllowedHours"
      :readonly="readonly"
      @update:timeIso="v => $emit('update:horario-inicial-iso', v)"
    />

    <time-picker
      label="Fim"
      hide-details
      :time-iso="horarioFinalIso"
      :min-time-iso="horarioMinimoIso"
      :max-time-iso="horarioMaximoIso"
      :allowed-hours="horarioFinalAllowedHours"
      :readonly="readonly"
      @update:timeIso="v => $emit('update:horario-final-iso', v)"
    />
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import TimePicker from '@/components/time-picker/TimePicker.vue'

export default {
  emits: ['update:horario-inicio-iso', 'update:horario-final-iso', 'update:horario-checkbox'],

  components: {
    TimePicker,
  },

  props: {
    titulo: {
      type: String,
      required: true,
    },
    horarioInicialIso: {
      type: String,
      default: null,
    },
    horarioFinalIso: {
      type: String,
      default: null,
    },
    horarioMinimoIso: {
      type: String,
      default: null,
    },
    horarioMaximoIso: {
      type: String,
      default: null,
    },
    horarioInicialAllowedHours: {
      type: Function,
      default: null,
    },
    horarioFinalAllowedHours: {
      type: Function,
      default: null,
    },
    readonly: Boolean,
  },

  setup(props, { emit }) {
    const isHorarioCheckboxMarcado = ref(false)

    watch(
      () => [props.horarioInicialIso, props.horarioFinalIso],
      ([inicial, final]) => {
        isHorarioCheckboxMarcado.value = !!inicial && !!final
      },
      {
        immediate: true,
      },
    )

    watch(
      isHorarioCheckboxMarcado,
      v => {
        emit('update:horario-checkbox', v)
      },
      {
        immediate: true,
      },
    )

    return {
      isHorarioCheckboxMarcado,
    }
  },
}
</script>
